<template>
  <div v-if="!meetRequisites">
    <span class="md-title"><b>Atenção!</b> seu aparelho não atende as especificações de utilização do aplicativo.</span>
    <span class="md-caption">Verifique os motivos abaixo e tente novamente.</span>
    <md-list>
      <md-list-item
        v-for="(msg, index) in messages"
        :key="index"
      >
        <md-icon>warning</md-icon><span>{{msg}}</span>
      </md-list-item>

      <md-list-item v-if="notEmptyObject(navigator)">
        <md-icon>web</md-icon> <span>{{navigator}}</span>
      </md-list-item>

      <md-list-item v-if="notEmptyObject(ram)">
        <md-icon>memory</md-icon> <span>{{ram}}</span>
      </md-list-item>

      <md-list-item v-if="notEmptyObject(storage)">
        <md-icon>storage</md-icon> <span>{{storage}}</span>
      </md-list-item>
    </md-list>
    <md-layout md-column>
      <span class="title">Você pode continuar, porém as funcionalidades serão reduzidas e você precisará de internet para capturar as fotos.</span>
      <md-button
        class="md-primary md-raised"
        @click="continueWithProcess"
      >Continuar com o Processo</md-button>
    </md-layout>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import is from 'is_js'
export default {
  name: 'check-requisites',
  computed: {
    ...mapState({
      continueWithMinimum: state => state.continueWithMinimum
    })
  },
  data: () => {
    return {
      storage: '',
      ram: '',
      navigator: '',
      messages: [],
      meetRequisites: true
    }
  },
  beforeMount () {
    if (this.continueWithMinimum) {
      console.log('APARELHO NÃO ATENDE E ESCOLHEU SEGUIR EM FRENTE')
      this.meetRequisites = true
      this.$emit('onRequisitesCheck', this.meetRequisites)
      return
    }
    this.FETCH_CONFIG('minRam').then((minRam) => {
      if (!this.hasMinimumRam(minRam)) {
        this.meetRequisites = false
        this.messages.push('Aparelho possui pouca memória RAM disponível')
      }
      Promise.resolve()
    }).then(() => {
      if (!this.isChrome()) {
        this.meetRequisites = false
        this.messages.push('Navegador imcompatível, por favor utilize Google Chrome v.71 ou superior.')
      }
    }).then(() => {
      return this.hasMinimumStorage().then(hasStorage => {
        if (!hasStorage) {
          this.meetRequisites = false
          this.messages.push('Aparelho não disponibiliza espaço em disco suficiente para continuar. Tente acessar utilizando o navegador Google Chrome e adicione o endereço do aplicativo ao favoritos.')
        }
        return Promise.resolve()
      })
    }).finally(() => {
      this.$emit('onRequisitesCheck', this.meetRequisites)
    })
  },
  methods: {
    ...mapActions(['FETCH_CONFIG', 'SET_CONTINUE_WITH_MINIMUM']),
    hasMinimumStorage () {
      if (!navigator.storage && !navigator.storage.estimate) { return Promise.resolve(false) }
      return navigator.storage.estimate().then((estimate) => {
        this.storage = this.formatBytes(estimate.usage) + ' utilizados de ' + this.formatBytes(estimate.quota)
        let usage = estimate.usage / estimate.quota * 100
        if (usage > 80) { return Promise.resolve(false) } else { return Promise.resolve(true) }
      })
    },
    hasMinimumRam (minRam) {
      if (is.desktop) { return true }

      var MIN_MEMORY_LIMIT = minRam * 1048576 // 1GB
      var MAX_PERCENT_THRESHOLD = 90

      if (!performance || !performance.memory) {
        return false
      }

      this.ram = this.formatBytes(performance.memory.jsHeapSizeLimit)

      if (performance.memory.jsHeapSizeLimit < MIN_MEMORY_LIMIT) { return false }

      if (performance.memory.usedJSHeapSize > (MAX_PERCENT_THRESHOLD / 100) * performance.memory.jsHeapSizeLimit) {
        this.memory += 'Limite de utilização de memória RAM alcançado, feche os aplicativos que não está utilizando para liberar memória e tente novamente.'
        return false
      }
      return true
    },
    isChrome () {
      var isChromium = window.chrome
      var winNav = window.navigator
      var vendorName = winNav.vendor
      var isOpera = typeof window.opr !== 'undefined'
      var isIEedge = winNav.userAgent.indexOf('Edge') > -1
      var isIOSChrome = winNav.userAgent.match('CriOS')

      if (isIOSChrome) {
        // is Google Chrome on IOS
        this.navigator = 'Google Chrome on IOS'
        return true
      } else if (
        isChromium !== null &&
        typeof isChromium !== 'undefined' &&
        vendorName === 'Google Inc.' &&
        isOpera === false &&
        isIEedge === false
      ) {
        // is Google Chrome
        this.navigator = 'Google Chrome'
        return true
      } else {
        if (is.desktop) {
          return true
        } else {
          // not Google Chrome
          this.navigator = winNav.userAgent
          return false
        }
      }
    },
    formatBytes (a, b) {
      if (a === 0) return '0 Bytes'
      var c = 1024
      var d = b || 2
      var e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      var f = Math.floor(Math.log(a) / Math.log(c))
      return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f]
    },
    notEmptyObject (someObject) {
      return Object.keys(someObject).length
    },
    continueWithProcess () {
      this.SET_CONTINUE_WITH_MINIMUM()
      this.meetRequisites = true
      this.$emit('onRequisitesCheck', true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CheckRequisites.vue?537cb8a0